module.exports = __webpack_public_path__ + "img/11223.8b258856.png";